export type A2pAnalysisSeverity = 'must_fix' | 'recommended' | 'other';

export interface A2pAnalysisItem {
  severity: A2pAnalysisSeverity;
  title: string;
  description: string;
  exampleWording?: string;
}

export interface A2pAnalysis {
  output: string;
  items: A2pAnalysisItem[];
}

export const SEVERITY_ORDER: Record<A2pAnalysisSeverity, number> = {
  must_fix: 0,
  recommended: 1,
  other: 2,
};
